import { useState } from 'react'
import Styles from './UploadsDrawer.module.scss'
import { NounProjectGrid } from 'components/Design/ElementsTab/components/NounProjectGrid'
import { useNounProjectIcons } from 'components/Design/ElementsTab/components/useNounProjectIcons'
import { SearchInput } from './components/SearchInput'
import { ShimmeringColor } from 'components/BrandWizardVisualAnalysisModal/LoadingState'
import { Text } from 'blaze-ui/Text/Text'
import { useDebounce } from 'hooks/useDebounce'

export const IconsPanel = () => {
  const [query, setQuery] = useState('')
  const debouncedQuery = useDebounce(query, 500)
  const { data: icons, isLoading } = useNounProjectIcons({ query: debouncedQuery })

  return (
    <div>
      <div className={Styles.searchContainer}>
        <SearchInput value={query} onChange={setQuery} />
      </div>
      {isLoading && (
        <div className={Styles.loadingGroup}>
          {Array.from({ length: 36 }).map((_, i) => (
            <div className={Styles.templatePreviewContainer} key={`loader-${i}`}>
              <ShimmeringColor aspectRatio={1} />
            </div>
          ))}
        </div>
      )}
      {!isLoading && icons && icons.length > 0 && (
        <div className={Styles.sectionContainer}>
          <NounProjectGrid iconsToShow={icons} />
        </div>
      )}
      {!isLoading && icons?.length === 0 && <Text variant="smallList">No results found for {debouncedQuery}.</Text>}
    </div>
  )
}
